var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTlntProBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2293.18,
    height: 278.476,
    viewBox: "0 0 2293.18 278.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1248.224 -564.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(1248.224 564.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M147.356,67H396.87V105.3H296.728V337.74h-48.84V105.3H147.356Z",
    transform: "translate(-147.356 -63.133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M223.38,67V299.456H352.57V337.74H174.919V67Z",
    transform: "translate(123.837 -63.133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M408.409,321.492V67h46.423V337.74H372.066l-130-254.489V337.74H195.629V67h82.777Z",
    transform: "translate(327.602 -63.133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M224.087,67h249.5V105.3H373.459V337.74h-48.84V105.3H224.087Z",
    transform: "translate(607.601 -63.133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M259.77,67H381.291Q479.8,67,479.8,157.5q0,92.441-100.121,92.436H354.244l-25.03-38.288h47.24q55.3,0,55.311-53.376,0-52.98-52.892-52.985H308.222V337.739H259.77Z",
    transform: "translate(958.689 -63.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M426,234.475l101.339,71.547L522.5,337.739h-46.43L382.807,236.4h-1.212l-30.683-34.423h45.218q59.747,0,59.752-49.12,0-47.566-54.9-47.571H333.551V337.739H285.1V67H404.2q99.322,0,99.323,82.766,0,73.493-77.521,84.707",
    transform: "translate(1207.894 -63.133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M580.164,311.857q-37.138,33.273-116.27,33.265T347.618,311.857q-36.747-33.649-36.744-105.97,0-72.71,36.744-105.59,37.138-33.648,116.275-33.651T580.164,100.3q37.146,33.265,37.146,105.59t-37.146,105.97m-195.406-31.33q23.824,22.438,79.135,22.438t78.727-22.438q24.223-22.813,24.22-74.64t-24.22-74.265q-23.832-22.8-78.727-22.818-54.5,0-79.135,22.818-23.824,22.829-23.818,74.265,0,51.83,23.818,74.64",
    transform: "translate(1461.498 -66.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M341.9,66.907h67.639V81.475H385.024V143H366.413V81.475H341.9Zm144.8,0h27.694L526.423,143h-17.7L498.506,79.735,481.711,143h-22.7l-16.8-63.269L431.78,143H414.3l12.029-76.1h27.46l16.567,64.356Z",
    transform: "translate(1766.756 -64.075)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTlntProBlack);
export default __webpack_public_path__ + "static/media/tlnt-pro-black.6d3143e27a7ea878fd9cde574298838c.svg";
export { ForwardRef as ReactComponent };